// extracted by mini-css-extract-plugin
export var hexAnimationContainer = "hex-animation-module--hexAnimationContainer--7f119";
export var spinDown = "hex-animation-module--spinDown--e3655";
export var spinUp = "hex-animation-module--spinUp--ee987";